<script setup>
import ApplicationLogo from '@/Components/ApplicationLogo.vue';
import { removeToken } from '@/Helpers/auth';
import { onMounted } from 'vue';
import AppHead from '../Components/AppHead.vue';
import { getVersionFromSubdomain } from '@/Composables/subdomains';

const version = getVersionFromSubdomain();

onMounted(() => {
  // Remove any API tokens relating to a logged-in user. This allows
  // a new token to be generated once we reach the dashboard.
  removeToken();
});

function goToIntellifloStore() {
  window.open(
    `https://store.gb.intelliflo.net/published-apps?search=zerokey&query=orderby.field%3DLastPublishedAt%26orderby.direction%3Ddesc%26category%3Dintelliflo%2520office%26search%3Dzerokey`,
    '_blank'
  );
}
</script>

<template>
  <AppHead />

  <div class="pt-6 sm:pt-4 bg-slate-100 pb-10 min-h-screen flex items-center">
    <div
      class="max-w-screen-xl mx-auto lg:flex lg:items-center w-full space-y-10"
    >
      <div class="w-full flex flex-col items-center">
        <div>
          <a href="https://zerokey.tech/" @click="(e) => e.stopPropagation()">
            <ApplicationLogo
              class="max-h-24 max-w-52 fill-current text-slate-500"
            />
          </a>
        </div>

        <div
          class="w-full sm:max-w-md mt-6 p-6 lg:p-8 bg-white overflow-hidden sm:rounded-xl ring-1 ring-gray-500/10 shadow sm:shadow-md"
        >
          <slot />
        </div>
      </div>

      <div
        v-if="version !== 'intelliflo'"
        class="md:px-6 w-full flex justify-center"
      >
        <div
          @click="goToIntellifloStore"
          class="bg-white sm:rounded-[20px] ring-1 ring-slate-900/5 shadow flex items-center sm:max-w-[550px] cursor-pointer"
        >
          <div class="pl-3 py-3 flex">
            <img
              :src="asset('images/logos/intelliflo_dark.png')"
              class="min-w-[100px] max-w-[100px]"
            />
          </div>
          <div class="pr-6 py-4 pl-5">
            <div class="font-semibold text-base">
              To create an account with intelliflo zerokey, please register via
              the intelliflo store.
            </div>
            <div class="text-slate-600 text-sm mt-1.5">
              Already have an intelliflo zerokey account?
              <a
                href="https://intelliflo.zerokey.tech/login"
                @click.stop="() => {}"
                class="text-blue-600 font-medium hover:underline"
                >Login here</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
